import api from "@/api/api-v2-config";

export async function getJournalEntryAxios() {    
    return await api.get("journalentrys/journalentry");
}

export async function getJournalEntryIDAxios(id) {    
    return await api.get("journalentrys/"+ id);
}

export async function deleteJournalEntryAxios(id) {    
    return await api.delete("journalentrys/" + id);
}

export async function postJournalEntryAxios(JournalEntry) {    
    return await api.post("journalentrys/journalentry", JournalEntry);
}

export async function putJournalEntryAxios(JournalEntry) {    
    return await api.put("journalentrys/", JournalEntry);
}

export async function getJournalEntryLinesAxios(id) {    
    return await api.get(`journalentrys/${id}/journalentrylines`);
}